import React, { forwardRef } from 'react';
import { Tooltip } from '@mui/material';
import cn from 'classnames';

export type TooltipIconButtonProps = {
  tooltip: string;
  side?: 'top' | 'bottom' | 'left' | 'right';
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  children: React.ReactNode;
};

const placementMap: Record<
  NonNullable<TooltipIconButtonProps['side']>,
  'top' | 'bottom' | 'left' | 'right'
> = {
  top: 'top',
  bottom: 'bottom',
  left: 'left',
  right: 'right',
};

export const TooltipIconButton = forwardRef<
  HTMLButtonElement,
  TooltipIconButtonProps
>(function TooltipIconButton(
  { children, tooltip, side = 'bottom', onClick, disabled, className },
  ref,
) {
  return (
    <Tooltip title={tooltip} placement={placementMap[side]}>
      <span>
        {/* span wrapper required for disabled tooltip support */}
        <button
          ref={ref}
          type="button"
          onClick={onClick}
          disabled={disabled}
          className={cn(
            'aui-button-icon inline-flex items-center justify-center rounded-full p-1 transition bg-gray-50',
            'hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed',
            className,
          )}
          aria-label={tooltip}
        >
          {children}
        </button>
      </span>
    </Tooltip>
  );
});
